import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { IconArrowUpRight } from "@tabler/icons-react";
import { fadeLeft, fadeRight } from "./animations";

export default function CourseSection({
  number,
  label,
  title,
  description,
  route,
  detail = false,
  children,
  gray = false,
}) {
  return (
    <section
      className={`
        py-20
        sm:py-24
        lg:py-28
        ${gray ? "bg-[#f6f6f6]" : "bg-white"}
      `}
    >
      <div
        className="
          mx-auto
          max-w-7xl
          px-5
          sm:px-8
          lg:px-10
        "
      >
        <div
          className="
            grid
            gap-10
            lg:grid-cols-[0.65fr_1.35fr]
            lg:gap-16
          "
        >
          <motion.div
            variants={fadeLeft}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.25 }}
          >
            <div className="flex items-start gap-5">
              <span
                className="
                  merriweather
                  text-5xl
                  font-light
                  tracking-[-0.05em]
                  text-neutral-200
                "
              >
                {number}
              </span>

              <div>
                <p
                  className="
                    text-[10px]
                    font-bold
                    uppercase
                    tracking-[0.2em]
                    text-[#55aef3]
                  "
                >
                  {label}
                </p>

                <h2
                  className="
                    merriweather
                    mt-3
                    text-3xl
                    font-black
                    tracking-[-0.04em]
                    sm:text-4xl
                    lg:text-[46px]
                    lg:leading-[1.08]
                  "
                >
                  {title}
                </h2>
              </div>
            </div>

            <p
              className="
                mt-6
                max-w-lg
                text-[15px]
                leading-8
                text-neutral-600
              "
            >
              {description}
            </p>

            <Link
              to={detail ? "/contact" : route}
              className="
                group
                mt-7
                inline-flex
                items-center
                gap-2
                text-sm
                font-bold
                text-neutral-950
              "
            >
              {detail ? `Enquire about ${title}` : `Explore ${title}`}

              <IconArrowUpRight
                size={16}
                className="
                  transition-transform
                  group-hover:translate-x-1
                  group-hover:-translate-y-1
                "
              />
            </Link>
          </motion.div>

          <motion.div
            variants={fadeRight}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.15 }}
          >
            {children}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
